/* selling-plan-consent-guard.js — Wonder v2.1.2 / Recharge widget
 * P0-1 (2026-07-02 CRO audit): plain "Add to cart" must never carry a
 * subscription selling plan the customer did not explicitly choose.
 * Recharge syncs a hidden selling_plan input into the theme's ATC form;
 * with the portal's subscription-first default (or a failed widget render)
 * that input holds a plan id before any customer choice.
 * Two invariants, enforced until the customer genuinely interacts with the
 * Recharge widget (isTrusted events only — the guard's own programmatic
 * clicks never count):
 *   1. The widget's one-time option is the selected default.
 *   2. A selling_plan field OUTSIDE the widget carries a value ONLY while
 *      a subscribe option is checked (covers failed-render loads too).
 */
(function () {
  'use strict';

  var RC_SCOPE = '.rc-container, .rc_container, .rc-widget';

  var interacted = false;
  function markInteracted(e) {
    if (!e.isTrusted) return;
    var t = e.target;
    if (t && t.closest && t.closest(RC_SCOPE)) interacted = true;
  }
  document.addEventListener('pointerdown', markInteracted, true);
  document.addEventListener('click', markInteracted, true);
  document.addEventListener('keydown', function (e) {
    if (!e.isTrusted) return;
    var ae = document.activeElement;
    if (ae && ae.closest && ae.closest(RC_SCOPE)) interacted = true;
  }, true);

  function subscribeChecked() {
    var radios = document.querySelectorAll(
      'input.rc_widget__option__input--subsave, input[name^="selling_plan_"][value="subsave"]'
    );
    for (var i = 0; i < radios.length; i++) if (radios[i].checked) return true;
    return false;
  }

  function enforce() {
    if (subscribeChecked()) return;
    var els = document.querySelectorAll('form[action*="/cart/add"] input[name="selling_plan"]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.closest(RC_SCOPE)) continue;
      if (el.value) el.value = '';
    }
  }

  function tryFlip() {
    if (interacted) return;
    var onetime = document.querySelector('input.rc_widget__option__input--onetime');
    var subsave = document.querySelector('input.rc_widget__option__input--subsave');
    if (onetime && subsave && subsave.checked && !onetime.checked) onetime.click();
  }

  function tick() { tryFlip(); enforce(); }

  /* Final synchronous gate: capture phase runs before the theme's
   * product-form submit handler serializes FormData. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && typeof form.action === 'string' && form.action.indexOf('/cart/add') !== -1) enforce();
  }, true);

  document.addEventListener('change', tick, true);

  var observer = new MutationObserver(tick);

  function start() {
    observer.observe(document.documentElement, { childList: true, subtree: true });
    var ticks = 0;
    var fast = setInterval(function () {
      tick();
      if (++ticks >= 50) { /* ~15s startup burst, then settle to 1s */
        clearInterval(fast);
        setInterval(tick, 1000);
      }
    }, 300);
    tick();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
